// extracted by mini-css-extract-plugin
export default {"button":"SelectionActionButton_button__7BtzeCLy","icon":"SelectionActionButton_icon__KltazMrr","text":"SelectionActionButton_text__fDNflhWZ"};